import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {VersionsService} from '../core/services/versions.service';
import {Injectable} from '@angular/core';
import {DIAGRAM_VERSION_STATES_ENUM} from '../editor-interface/shared/models/diagram-version.constant';

@Injectable()
export class QueryParamGuard {
  constructor(
    private router: Router,
    private versionsSvc: VersionsService
  ) {}

  canActivateChild(snapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!snapshot.queryParams.v) {
      // presence of v param is critical requirement
      this.versionsSvc.forceDraft = true;

      return this.router.createUrlTree(['diagram', snapshot.params.diagramId], {
        queryParams: {
          ...snapshot.queryParams,
          v: DIAGRAM_VERSION_STATES_ENUM.MASTER
        }
      });
    }

    return true;
  }
}
